import React, {FC} from 'react';
import {InformerConfigProvider} from '@/informers/services/informerConfigReducer';
import {useLocalizer} from '@/common/services/localizer';
import {Form} from '@/informers/components/form';
import {Preview} from '@/informers/components/preview';
import styles from './AppConstructor.css';

export const AppConstructor: FC = () => {
	const t = useLocalizer();

	return (
		<InformerConfigProvider defaultLanguage={t.language}>
			<main className={styles.root}>
				<Form />
				<Preview />
			</main>
		</InformerConfigProvider>
	);
};

AppConstructor.displayName = 'AppConstructor';
